export default {"src":"/_next/static/media/Down-Arrow-Accordion.47bc6c8e.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};